export class MotivosTramitesUacListPK {
    public idMotivoConsulta: string;
    public estado: string;
}

export class MotivosTramitesUacList {
    public id: string;
    public idTramite: string;
    public motivosConsulta: MotivosTramitesUacListPK [];
    public fechaCreacion: Date;
    public fechaModificacion: Date;
    public usuarioModificacion: string;

}